import {V1ETLJobIDOCToArray} from "../../../../util/Payload";
import EnterpriseComponent from "../../EnterpriseComponent";
import {v4 as uuidv4} from "uuid";
import EnlilAxios from "../../../../util/EnlilAxios";
import {SessionContext} from "../../../../util/SessionContext";

class ETLJobEnterpriseComponent extends EnterpriseComponent {
    performQuery = (page, pageSize, foreignKey) => {
        page = page || 1;
        pageSize = pageSize || this.getDefaultCacheSize();

        this.notifyLoadStartListeners();

        let QBE = {
            "ShifamedMessage": {
                "-idoc": "v1.ETLJob-001",
                "-id": uuidv4(),
                "ETLJob": {
                    '_attributes': {
                        'limit': pageSize,
                        'sort': this.getFormattedSortSpecification(),
                        'offset': (page - 1) * pageSize
                    },
                    "QueryGroups": {
                        "QueryGroup": [
                            {
                                "Name": "primary",
                                "Operator": "AND",
                                "Type": "QueryGroup",
                                "Membership": {
                                    "Member": []
                                }
                            }
                        ]
                    }
                }
            }
        }
        let queryPayload = this.prepareQueryPayload();

        if (queryPayload.size > 0) {
            for (const [key, value] of queryPayload) {
                if (key.includes("_query")) continue;

                let operator = "EQUAL";
                if (queryPayload.get(key + "_query") !== undefined) {
                    operator = queryPayload.get(key + "_query")
                }
                QBE.ShifamedMessage.ETLJob.QueryGroups.QueryGroup[0].Membership.Member.push({
                    "Type": "Attribute",
                    "Name": key,
                    "Value": value,
                    "Operator": operator
                })
            }
        }

        EnlilAxios({
            method: "GET",
            url: "t1/v1/etl_jobs",
            json: true,
            params: {
                "QBE": btoa(JSON.stringify(QBE))
            },
            headers: {
                "idoc-response": this.getIDOCResponse() ?? "v1.ETLJob-001",
            },
        }).then(response => {
            this.fetchEnterpriseComponentSuccess(V1ETLJobIDOCToArray(response.data), page, pageSize);
        }).catch(error => {
            this.fetchEnterpriseComponentFailed(error);
        });
    };

    enterpriseComponentPostIDOC = () => {
        let payload = {};

        let job = {};

        let sessionContext = new SessionContext();

        job["USID"] = this.getAttributeValue("USID");
        job["Name"] = this.getAttributeValue("Name");
        job["OwnerUSID"] = sessionContext.getEmployeeUSID();
        job["Type"] = this.getAttributeValue("Type");
        job["SubType"] = this.getAttributeValue("SubType");
        job["Specification"] = this.getAttributeValue("Specification");
        job["Status"] = 'Active';

        payload.ShifamedMessage = {};
        payload.ShifamedMessage["-idoc"] = "v1.ETLJob-001";
        payload.ShifamedMessage.ETLJob = job;

        return payload;
    };

    performInsert() {
        let payload = this.enterpriseComponentPostIDOC();

        let options = {
            method: "POST",
            url: "t1/v1/etl_jobs",
            json: true,
            data: payload,
            headers: {
                "idoc-request": "v1.ETLJob-001",
                "idoc-response": "v1.ETLJob-001"
            },
        };
        this.notifyInsertStartListeners();
        EnlilAxios(options)
            .then(response => {
                this.insertEnterpriseComponentSuccess(V1ETLJobIDOCToArray(response.data));
            })
            .catch(error => {
                this.insertEnterpriseComponentFailed(error);
            });
    };

}

export default ETLJobEnterpriseComponent;